import modals from "./modals";
import toggle from "./toggle";

export default {
  ...modals,
  ...toggle,
};
